import Service from './Service';

/**
 * 授信钱包端接口
 */
class CreditWalletService extends Service {
    /**
     * 授信账单--授信授予方列表(钱包)
     */
    queryCreditGrantMerchantList() {
        return this.axios.get('api/pay/v1/credit/wallet/grant-merchant-list');
    }
    /**
     * 授信账单--授信授予方列表(钱包)
     */
    queryCreditGrantMerchantListSync() {
        return this.axios.get('api/pay/v1/credit/wallet/grant-merchant-list', {});
    }

    /**
     * 授信账单--统计信息(钱包)
     */
    queryCreditWalletStatistics(params) {
        return this.axios.get('api/pay/v1/credit/wallet/statistics', { params });
    }

    /**
     * 授信账单--月度账单统计(钱包)
     */
    queryCreditWalletMonthBillStatistics(params) {
        return this.axios.get('api/pay/v1/credit/wallet/month-bill-statistics', { params });
    }

    /**
     * 授信账单--月度账单交易列表(钱包)
     */
    queryCreditWalletMonthBillTradeList(params) {
        return this.axios.get('api/pay/v1/credit/wallet/month-bill-trade-list', { params });
    }

    /**
     * 授信充值--根据商户查询授信充值渠道(钱包)
     */
    queryRechargePayChannels(params) {
        return this.axios.get('api/pay/v1/credit/wallet/recharge-pay-channels', { params });
    }
}

const creditWalletService = new CreditWalletService();
export default creditWalletService;
